import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '@/hooks';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { useUpdateServiceVisitTypeMutation } from '../services';
import {
  ServiceVisitTypeFormValues,
  toServiceVisitTypePayload,
} from '../models';

const LIST_PATH = '/business/service-visit-types';

const useUpdateServiceVisitType = () => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  const [updateServiceVisitType, { isLoading: isUpdating }] =
    useUpdateServiceVisitTypeMutation();

  const handleUpdate = useCallback(
    async (id: string, values: ServiceVisitTypeFormValues): Promise<void> => {
      try {
        const payload = toServiceVisitTypePayload(values);
        await updateServiceVisitType({ id, body: payload }).unwrap();
        showNotification(
          'Tipo de visita actualizado exitosamente',
          NotificationSeverity.success
        );
        setTimeout(() => navigate(LIST_PATH), 500);
      } catch (error: any) {
        const message =
          error?.data?.message ??
          error?.message ??
          'Error al actualizar el tipo de visita';
        showNotification(message, NotificationSeverity.error);
      }
    },
    [updateServiceVisitType, showNotification, navigate]
  );

  return { handleUpdate, isUpdating };
};

export default useUpdateServiceVisitType;
